module.exports = __webpack_public_path__ + "media/images/sw-logo-light-06791a7027f9d8fc96418731c32ce37a.svg";